import React from 'react';

class BanAutoCompleteResult extends React.Component {

    constructor(props) {
        super(props);
        this.renderItem = this.renderItem.bind(this)
    }

    renderItem(item, key) {
        return (
            <li key={key} className={'result-item'}>
                <a  href="#"
                    onClick={(e) => {this.props.selectResult(item.properties.id)}}>
                    { item.properties.name }, { item.properties.context }
                </a>
            </li>);
    }

    selectOption(id) {
        return () => { this.props.selectResult() }
    }

    render() {

            return(
                (this.props.results.length)?
                <div className={'ue-filter-panel'} style={{'zIndex': '10000000000000'}}>
                    <div className="">
                        <ul className="results">
                            { this.props.results.map(this.renderItem) }
                        </ul>
                    </div>
                </div>
                :null
            );
    }
}

export default BanAutoCompleteResult;
